// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   设计系统 — 现代简约
   亮/暗双主题，通过 body[theme-mode="dark"] 切换（与 ThemeProvider 一致）
   ============================================================ */

:root {
  /* 页面与表面 */
  --page-bg: #f9f9f7;
  --surface: #fcfcfb;
  --surface-2: #f3f3f0;

  /* 文字 */
  --text-1: #0b0b0b;
  --text-2: #52514e;
  --text-3: #898781;

  /* 线条 */
  --hairline: #e1e0d9;
  --border: rgba(11, 11, 11, 0.10);

  /* 主色与图表系列（已通过对比度/色盲校验） */
  --accent: #2a78d6;
  --accent-strong: #1c5cab;
  --accent-soft: rgba(42, 120, 214, 0.10);
  --series-1: #2a78d6;
  --series-2: #008300;
  --series-cache: #1baf7a;

  /* 状态 */
  --good: #0ca30c;
  --good-text: #006300;
  --warning: #fab219;
  --critical: #d03b3b;

  /* 圆角与阴影 */
  --radius-lg: 16px;
  --radius-md: 12px;
  --radius-sm: 8px;
  --shadow-card: 0 1px 2px rgba(11, 11, 11, 0.04), 0 8px 24px -12px rgba(11, 11, 11, 0.10);
  --shadow-pop: 0 4px 16px -4px rgba(11, 11, 11, 0.16);

  /* 光晕背景 */
  --aurora-1: rgba(42, 120, 214, 0.14);
  --aurora-2: rgba(27, 175, 122, 0.10);
  --aurora-3: rgba(74, 58, 167, 0.08);
}

body[theme-mode='dark'] {
  --page-bg: #0d0d0d;
  --surface: #1a1a19;
  --surface-2: #232322;

  --text-1: #ffffff;
  --text-2: #c3c2b7;
  --text-3: #898781;

  --hairline: #2c2c2a;
  --border: rgba(255, 255, 255, 0.10);

  --accent: #3987e5;
  --accent-strong: #6da7ec;
  --accent-soft: rgba(57, 135, 229, 0.16);
  --series-1: #3987e5;
  --series-2: #008300;
  --series-cache: #199e70;

  --good: #0ca30c;
  --good-text: #0ca30c;

  --shadow-card: 0 1px 2px rgba(0, 0, 0, 0.4), 0 8px 24px -12px rgba(0, 0, 0, 0.5);
  --shadow-pop: 0 4px 16px -4px rgba(0, 0, 0, 0.6);

  --aurora-1: rgba(57, 135, 229, 0.12);
  --aurora-2: rgba(25, 158, 112, 0.08);
  --aurora-3: rgba(144, 133, 233, 0.08);
}

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  background: var(--page-bg);
  color: var(--text-1);
  font-family: system-ui, -apple-system, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  transition: background-color 0.3s ease, color 0.3s ease;
}

code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, 'Courier New', monospace;
}

/* Semi UI 主色对齐 */
body {
  --semi-color-primary: var(--accent);
  --semi-color-primary-hover: var(--accent-strong);
}

/* ============ 页面骨架 ============ */

.app-shell {
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
}

/* 顶部光晕（低饱和、不喧宾夺主） */
.app-aurora {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  background:
    radial-gradient(600px 320px at 12% -4%, var(--aurora-1), transparent 70%),
    radial-gradient(720px 360px at 88% -8%, var(--aurora-3), transparent 70%),
    radial-gradient(520px 300px at 55% -12%, var(--aurora-2), transparent 70%);
}

.app-main {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px 64px;
}

/* ============ 顶栏 ============ */

.app-header {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 24px 8px;
}

.app-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-1);
}

.app-brand-logo {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  color: #fff;
  background: linear-gradient(135deg, var(--accent), #1baf7a);
  box-shadow: 0 2px 8px -2px var(--accent-soft);
}

.app-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.icon-btn {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--text-2);
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.icon-btn:hover {
  background: var(--accent-soft);
  color: var(--accent);
}

/* ============ Hero 查询区 ============ */

.hero {
  text-align: center;
  padding: 40px 0 28px;
}

.hero-title {
  margin: 0;
  font-size: clamp(28px, 5vw, 40px);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.15;
  background: linear-gradient(92deg, var(--text-1) 20%, var(--accent) 60%, #1baf7a 95%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-sub {
  margin: 12px 0 0;
  font-size: 15px;
  color: var(--text-2);
}

.search-card {
  display: flex;
  gap: 10px;
  align-items: center;
  max-width: 720px;
  margin: 28px auto 0;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 18px;
  background: color-mix(in srgb, var(--surface) 82%, transparent);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow: var(--shadow-card);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.search-card:focus-within {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft), var(--shadow-card);
}

.search-card .semi-input-wrapper {
  flex: 1 1;
  background: transparent;
  border: none;
}

.search-card .semi-input-wrapper:hover,
.search-card .semi-input-wrapper-focus {
  background: transparent;
  border: none;
  box-shadow: none;
}

.search-card .semi-input {
  font-size: 15px;
}

/* ============ 通用卡片 ============ */

.panel {
  position: relative;
  margin-top: 20px;
  padding: 20px 24px;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
  box-shadow: var(--shadow-card);
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-1);
}

.panel-title .panel-title-dot {
  width: 8px;
  height: 8px;
  border-radius: 3px;
  background: var(--accent);
  flex-shrink: 0;
}

.panel-sub {
  font-size: 12px;
  color: var(--text-3);
}

/* 可折叠卡片标题按钮 */
.panel-title-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 4px;
  margin: -2px -4px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  color: inherit;
  font: inherit;
  text-align: left;
}

.panel-title-toggle:hover {
  background: var(--accent-soft);
}

.panel-chevron {
  color: var(--text-3);
  transition: transform 0.2s ease;
  flex-shrink: 0;
}

.panel-chevron.collapsed {
  transform: rotate(-90deg);
}

.panel-head-extra {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* ============ KPI 瓦片 ============ */

.tiles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
  gap: 12px;
  margin-top: 20px;
}

.stat-tile {
  padding: 16px 18px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface);
  box-shadow: var(--shadow-card);
  transition: transform 0.18s ease, box-shadow 0.18s ease;
}

.stat-tile:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-pop);
}

.stat-tile-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-3);
}

.stat-tile-label .tile-icon {
  display: inline-flex;
  color: var(--accent);
}

.stat-tile-value {
  margin-top: 6px;
  font-size: 26px;
  font-weight: 650;
  letter-spacing: -0.01em;
  color: var(--text-1);
  line-height: 1.1;
}

.stat-tile-sub {
  margin-top: 6px;
  font-size: 12px;
  color: var(--text-2);
}

/* ============ 令牌信息卡 ============ */

.token-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
}

.token-info-item .label {
  font-size: 12px;
  color: var(--text-3);
}

.token-info-item .value {
  margin-top: 4px;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-1);
}

.meter {
  margin-top: 16px;
}

.meter-track {
  height: 8px;
  border-radius: 999px;
  background: var(--accent-soft);
  overflow: hidden;
}

.meter-fill {
  height: 100%;
  border-radius: 999px;
  background: var(--accent);
  transition: width 0.6s cubic-bezier(0.22, 1, 0.36, 1);
}

.meter-fill.warn {
  background: var(--warning);
}

.meter-fill.danger {
  background: var(--critical);
}

.meter-caption {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  font-size: 12px;
  color: var(--text-3);
}

/* ============ 筛选行 ============ */

.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
  padding: 12px 16px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface);
  box-shadow: var(--shadow-card);
}

.filter-row .filter-label {
  font-size: 13px;
  color: var(--text-3);
  margin-right: 2px;
}

.filter-date {
  width: 250px;
}

.filter-models {
  min-width: 200px;
  max-width: 340px;
}

.filter-search {
  width: 220px;
}

.preset-group {
  display: inline-flex;
  gap: 4px;
  padding: 3px;
  border-radius: 10px;
  background: var(--surface-2);
}

.preset-btn {
  padding: 5px 12px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  color: var(--text-2);
  background: transparent;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
  white-space: nowrap;
}

.preset-btn:hover {
  color: var(--text-1);
}

.preset-btn.active {
  background: var(--surface);
  color: var(--accent);
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(11, 11, 11, 0.12);
}

/* ============ 图表 ============ */

.chart-wrap {
  position: relative;
}

.chart-svg {
  display: block;
  width: 100%;
}

.chart-svg .band:focus {
  outline: none;
}

.chart-svg .band:focus-visible .band-indicator {
  opacity: 1;
}

.chart-tooltip {
  position: absolute;
  z-index: 5;
  min-width: 150px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface);
  box-shadow: var(--shadow-pop);
  pointer-events: none;
  font-size: 12px;
  color: var(--text-2);
}

.chart-tooltip .tt-title {
  font-size: 12px;
  color: var(--text-3);
  margin-bottom: 6px;
}

.chart-tooltip .tt-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 3px;
}

.chart-tooltip .tt-key {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--text-2);
}

.chart-tooltip .tt-key .key-line {
  width: 10px;
  height: 3px;
  border-radius: 2px;
  flex-shrink: 0;
}

.chart-tooltip .tt-val {
  font-weight: 650;
  color: var(--text-1);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.chart-legend {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 12px;
  color: var(--text-2);
}

.chart-legend .legend-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.chart-legend .legend-swatch {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  flex-shrink: 0;
}

.chart-empty {
  display: grid;
  place-items: center;
  height: 200px;
  color: var(--text-3);
  font-size: 13px;
}

/* 指标切换（segmented） */
.seg-group {
  display: inline-flex;
  gap: 4px;
  padding: 3px;
  border-radius: 10px;
  background: var(--surface-2);
}

.seg-btn {
  padding: 4px 12px;
  border: none;
  border-radius: 8px;
  font-size: 12.5px;
  color: var(--text-2);
  background: transparent;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
  white-space: nowrap;
}

.seg-btn.active {
  background: var(--surface);
  color: var(--accent);
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(11, 11, 11, 0.12);
}

/* ============ 模型占比内嵌条 ============ */

.share-cell {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 110px;
}

.share-bar-track {
  flex: 1 1;
  height: 6px;
  border-radius: 999px;
  background: var(--accent-soft);
  overflow: hidden;
}

.share-bar-fill {
  height: 100%;
  border-radius: 999px;
  background: var(--series-1);
}

.share-cell .share-num {
  font-size: 12px;
  color: var(--text-2);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  min-width: 44px;
  text-align: right;
}

/* ============ 缓存徽标 ============ */

.cache-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  line-height: 1;
  color: var(--text-2);
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.cache-chip .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

/* ============ 空状态 ============ */

.empty-state {
  text-align: center;
  padding: 72px 24px;
  color: var(--text-3);
}

.empty-state .empty-icon {
  display: inline-grid;
  place-items: center;
  width: 64px;
  height: 64px;
  border-radius: 20px;
  background: var(--accent-soft);
  color: var(--accent);
  margin-bottom: 16px;
}

.empty-state .empty-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-2);
}

.empty-state .empty-sub {
  margin-top: 6px;
  font-size: 13px;
}

/* ============ Semi 组件微调 ============ */

.panel .semi-table {
  background: transparent;
}

.panel .semi-table-tbody > .semi-table-row > .semi-table-row-cell {
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.panel .semi-tabs-bar {
  border-bottom: 1px solid var(--hairline);
}

.site-tabs .semi-tabs-tab {
  font-size: 14px;
}

/* ============ 动画 ============ */

.fade-up {
  animation: fadeUp 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.fade-up-1 { animation-delay: 0.05s; }
.fade-up-2 { animation-delay: 0.10s; }
.fade-up-3 { animation-delay: 0.15s; }
.fade-up-4 { animation-delay: 0.20s; }

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* ============ 响应式 ============ */

@media (max-width: 640px) {
  .app-main {
    padding: 0 12px 48px;
  }

  .app-header {
    padding: 14px 16px 4px;
  }

  .hero {
    padding: 22px 0 12px;
  }

  .hero-sub {
    font-size: 13.5px;
    padding: 0 8px;
  }

  .search-card {
    flex-direction: column;
    align-items: stretch;
    padding: 12px;
  }

  .search-card .semi-button {
    width: 100%;
  }

  .panel {
    margin-top: 14px;
    padding: 14px;
    border-radius: var(--radius-md);
  }

  .panel-head {
    margin-bottom: 12px;
  }

  /* 折叠标题在窄屏下可换行 */
  .panel-title-toggle {
    flex-wrap: wrap;
  }

  .panel-head-extra {
    width: 100%;
    justify-content: flex-end;
  }

  /* KPI 瓦片固定两列，字号适度加大保证可读性 */
  .tiles-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 14px;
  }

  .stat-tile {
    padding: 14px;
  }

  .stat-tile-value {
    font-size: 24px;
  }

  .stat-tile-sub {
    font-size: 11.5px;
  }

  /* 令牌信息两列 */
  .token-info-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .token-info-item .value {
    font-size: 16px;
  }

  /* 筛选行：时间预设占满一行可横向滑动，其余控件全宽堆叠 */
  .filter-row {
    margin-top: 14px;
    padding: 12px;
  }

  .filter-row > .semi-icon {
    display: none;
  }

  .preset-group {
    display: flex;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .preset-btn {
    flex: 1 1;
    padding: 7px 8px;
    text-align: center;
  }

  .filter-date,
  .filter-models,
  .filter-search {
    width: 100% !important;
    max-width: none;
  }

  /* 图表头部控件占满一行，图例换行显示 */
  .seg-group {
    flex: 1 1;
    display: flex;
  }

  .seg-btn {
    flex: 1 1;
    text-align: center;
    padding: 6px 8px;
  }

  .chart-legend {
    width: 100%;
    justify-content: flex-end;
  }

  .empty-state {
    padding: 48px 16px;
  }

  /* 窄屏隐藏"显示第 x 条-第 y 条"信息文字，避免挤压竖排 */
  .semi-table-pagination-info {
    display: none;
  }

  .semi-table-pagination-outer {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;;EAEpB,OAAO;EACP,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,OAAO;EACP,mBAAmB;EACnB,gCAAgC;;EAEhC,yBAAyB;EACzB,iBAAiB;EACjB,wBAAwB;EACxB,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;;EAEvB,OAAO;EACP,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;;EAEnB,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,wFAAwF;EACxF,oDAAoD;;EAEpD,SAAS;EACT,oCAAoC;EACpC,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;;EAEpB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,mBAAmB;EACnB,mCAAmC;;EAEnC,iBAAiB;EACjB,wBAAwB;EACxB,uCAAuC;EACvC,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,oBAAoB;;EAEpB,gFAAgF;EAChF,gDAAgD;;EAEhD,oCAAoC;EACpC,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,+FAA+F;EAC/F,mCAAmC;EACnC,kCAAkC;EAClC,uDAAuD;AACzD;;AAEA;EACE,oFAAoF;AACtF;;AAEA,iBAAiB;AACjB;EACE,mCAAmC;EACnC,gDAAgD;AAClD;;AAEA,mCAAmC;;AAEnC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV;;;8EAG4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,oBAAoB;AACtB;;AAEA,iCAAiC;;AAEjC;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,2DAA2D;EAC3D,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA,uCAAuC;;AAEvC;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,qFAAqF;EACrF,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,+DAA+D;EAC/D,2BAA2B;EAC3B,mCAAmC;EACnC,8BAA8B;EAC9B,wDAAwD;AAC1D;;AAEA;EACE,2BAA2B;EAC3B,4DAA4D;AAC9D;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,mCAAmC;;AAEnC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,8BAA8B;EAC9B,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA,oCAAoC;;AAEpC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA,iCAAiC;;AAEjC;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,yDAAyD;EACzD,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA,sCAAsC;;AAEtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,6BAAkC;EAAlC,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA,mCAAmC;;AAEnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,kCAAkC;;AAElC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA,wCAAwC;;AAExC;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA,iCAAiC;;AAEjC;EACE,0DAA0D;AAC5D;;AAEA,aAAa,sBAAsB,EAAE;AACrC,aAAa,sBAAsB,EAAE;AACrC,aAAa,sBAAsB,EAAE;AACrC,aAAa,sBAAsB,EAAE;;AAErC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA,kCAAkC;;AAElC;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;EACrB;;EAEA,gBAAgB;EAChB;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA,2BAA2B;EAC3B;IACE,gDAAgD;IAChD,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,WAAW;EACX;IACE,gDAAgD;IAChD,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA,+BAA+B;EAC/B;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;;IAGE,sBAAsB;IACtB,eAAe;EACjB;;EAEA,sBAAsB;EACtB;IACE,SAAO;IACP,aAAa;EACf;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA,mCAAmC;EACnC;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* ============================================================\n   设计系统 — 现代简约\n   亮/暗双主题，通过 body[theme-mode=\"dark\"] 切换（与 ThemeProvider 一致）\n   ============================================================ */\n\n:root {\n  /* 页面与表面 */\n  --page-bg: #f9f9f7;\n  --surface: #fcfcfb;\n  --surface-2: #f3f3f0;\n\n  /* 文字 */\n  --text-1: #0b0b0b;\n  --text-2: #52514e;\n  --text-3: #898781;\n\n  /* 线条 */\n  --hairline: #e1e0d9;\n  --border: rgba(11, 11, 11, 0.10);\n\n  /* 主色与图表系列（已通过对比度/色盲校验） */\n  --accent: #2a78d6;\n  --accent-strong: #1c5cab;\n  --accent-soft: rgba(42, 120, 214, 0.10);\n  --series-1: #2a78d6;\n  --series-2: #008300;\n  --series-cache: #1baf7a;\n\n  /* 状态 */\n  --good: #0ca30c;\n  --good-text: #006300;\n  --warning: #fab219;\n  --critical: #d03b3b;\n\n  /* 圆角与阴影 */\n  --radius-lg: 16px;\n  --radius-md: 12px;\n  --radius-sm: 8px;\n  --shadow-card: 0 1px 2px rgba(11, 11, 11, 0.04), 0 8px 24px -12px rgba(11, 11, 11, 0.10);\n  --shadow-pop: 0 4px 16px -4px rgba(11, 11, 11, 0.16);\n\n  /* 光晕背景 */\n  --aurora-1: rgba(42, 120, 214, 0.14);\n  --aurora-2: rgba(27, 175, 122, 0.10);\n  --aurora-3: rgba(74, 58, 167, 0.08);\n}\n\nbody[theme-mode='dark'] {\n  --page-bg: #0d0d0d;\n  --surface: #1a1a19;\n  --surface-2: #232322;\n\n  --text-1: #ffffff;\n  --text-2: #c3c2b7;\n  --text-3: #898781;\n\n  --hairline: #2c2c2a;\n  --border: rgba(255, 255, 255, 0.10);\n\n  --accent: #3987e5;\n  --accent-strong: #6da7ec;\n  --accent-soft: rgba(57, 135, 229, 0.16);\n  --series-1: #3987e5;\n  --series-2: #008300;\n  --series-cache: #199e70;\n\n  --good: #0ca30c;\n  --good-text: #0ca30c;\n\n  --shadow-card: 0 1px 2px rgba(0, 0, 0, 0.4), 0 8px 24px -12px rgba(0, 0, 0, 0.5);\n  --shadow-pop: 0 4px 16px -4px rgba(0, 0, 0, 0.6);\n\n  --aurora-1: rgba(57, 135, 229, 0.12);\n  --aurora-2: rgba(25, 158, 112, 0.08);\n  --aurora-3: rgba(144, 133, 233, 0.08);\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  background: var(--page-bg);\n  color: var(--text-1);\n  font-family: system-ui, -apple-system, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\ncode {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, 'Courier New', monospace;\n}\n\n/* Semi UI 主色对齐 */\nbody {\n  --semi-color-primary: var(--accent);\n  --semi-color-primary-hover: var(--accent-strong);\n}\n\n/* ============ 页面骨架 ============ */\n\n.app-shell {\n  position: relative;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n/* 顶部光晕（低饱和、不喧宾夺主） */\n.app-aurora {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 0;\n  background:\n    radial-gradient(600px 320px at 12% -4%, var(--aurora-1), transparent 70%),\n    radial-gradient(720px 360px at 88% -8%, var(--aurora-3), transparent 70%),\n    radial-gradient(520px 300px at 55% -12%, var(--aurora-2), transparent 70%);\n}\n\n.app-main {\n  position: relative;\n  z-index: 1;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px 64px;\n}\n\n/* ============ 顶栏 ============ */\n\n.app-header {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px 24px 8px;\n}\n\n.app-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-1);\n}\n\n.app-brand-logo {\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 10px;\n  color: #fff;\n  background: linear-gradient(135deg, var(--accent), #1baf7a);\n  box-shadow: 0 2px 8px -2px var(--accent-soft);\n}\n\n.app-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.icon-btn {\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--text-2);\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.icon-btn:hover {\n  background: var(--accent-soft);\n  color: var(--accent);\n}\n\n/* ============ Hero 查询区 ============ */\n\n.hero {\n  text-align: center;\n  padding: 40px 0 28px;\n}\n\n.hero-title {\n  margin: 0;\n  font-size: clamp(28px, 5vw, 40px);\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n  background: linear-gradient(92deg, var(--text-1) 20%, var(--accent) 60%, #1baf7a 95%);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.hero-sub {\n  margin: 12px 0 0;\n  font-size: 15px;\n  color: var(--text-2);\n}\n\n.search-card {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  max-width: 720px;\n  margin: 28px auto 0;\n  padding: 10px;\n  border: 1px solid var(--border);\n  border-radius: 18px;\n  background: color-mix(in srgb, var(--surface) 82%, transparent);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  box-shadow: var(--shadow-card);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.search-card:focus-within {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft), var(--shadow-card);\n}\n\n.search-card .semi-input-wrapper {\n  flex: 1;\n  background: transparent;\n  border: none;\n}\n\n.search-card .semi-input-wrapper:hover,\n.search-card .semi-input-wrapper-focus {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n}\n\n.search-card .semi-input {\n  font-size: 15px;\n}\n\n/* ============ 通用卡片 ============ */\n\n.panel {\n  position: relative;\n  margin-top: 20px;\n  padding: 20px 24px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  background: var(--surface);\n  box-shadow: var(--shadow-card);\n}\n\n.panel-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.panel-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-1);\n}\n\n.panel-title .panel-title-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 3px;\n  background: var(--accent);\n  flex-shrink: 0;\n}\n\n.panel-sub {\n  font-size: 12px;\n  color: var(--text-3);\n}\n\n/* 可折叠卡片标题按钮 */\n.panel-title-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 2px 4px;\n  margin: -2px -4px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n}\n\n.panel-title-toggle:hover {\n  background: var(--accent-soft);\n}\n\n.panel-chevron {\n  color: var(--text-3);\n  transition: transform 0.2s ease;\n  flex-shrink: 0;\n}\n\n.panel-chevron.collapsed {\n  transform: rotate(-90deg);\n}\n\n.panel-head-extra {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* ============ KPI 瓦片 ============ */\n\n.tiles-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.stat-tile {\n  padding: 16px 18px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--surface);\n  box-shadow: var(--shadow-card);\n  transition: transform 0.18s ease, box-shadow 0.18s ease;\n}\n\n.stat-tile:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-pop);\n}\n\n.stat-tile-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: var(--text-3);\n}\n\n.stat-tile-label .tile-icon {\n  display: inline-flex;\n  color: var(--accent);\n}\n\n.stat-tile-value {\n  margin-top: 6px;\n  font-size: 26px;\n  font-weight: 650;\n  letter-spacing: -0.01em;\n  color: var(--text-1);\n  line-height: 1.1;\n}\n\n.stat-tile-sub {\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--text-2);\n}\n\n/* ============ 令牌信息卡 ============ */\n\n.token-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 16px;\n}\n\n.token-info-item .label {\n  font-size: 12px;\n  color: var(--text-3);\n}\n\n.token-info-item .value {\n  margin-top: 4px;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-1);\n}\n\n.meter {\n  margin-top: 16px;\n}\n\n.meter-track {\n  height: 8px;\n  border-radius: 999px;\n  background: var(--accent-soft);\n  overflow: hidden;\n}\n\n.meter-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: var(--accent);\n  transition: width 0.6s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.meter-fill.warn {\n  background: var(--warning);\n}\n\n.meter-fill.danger {\n  background: var(--critical);\n}\n\n.meter-caption {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 6px;\n  font-size: 12px;\n  color: var(--text-3);\n}\n\n/* ============ 筛选行 ============ */\n\n.filter-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 20px;\n  padding: 12px 16px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--surface);\n  box-shadow: var(--shadow-card);\n}\n\n.filter-row .filter-label {\n  font-size: 13px;\n  color: var(--text-3);\n  margin-right: 2px;\n}\n\n.filter-date {\n  width: 250px;\n}\n\n.filter-models {\n  min-width: 200px;\n  max-width: 340px;\n}\n\n.filter-search {\n  width: 220px;\n}\n\n.preset-group {\n  display: inline-flex;\n  gap: 4px;\n  padding: 3px;\n  border-radius: 10px;\n  background: var(--surface-2);\n}\n\n.preset-btn {\n  padding: 5px 12px;\n  border: none;\n  border-radius: 8px;\n  font-size: 13px;\n  color: var(--text-2);\n  background: transparent;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n  white-space: nowrap;\n}\n\n.preset-btn:hover {\n  color: var(--text-1);\n}\n\n.preset-btn.active {\n  background: var(--surface);\n  color: var(--accent);\n  font-weight: 600;\n  box-shadow: 0 1px 3px rgba(11, 11, 11, 0.12);\n}\n\n/* ============ 图表 ============ */\n\n.chart-wrap {\n  position: relative;\n}\n\n.chart-svg {\n  display: block;\n  width: 100%;\n}\n\n.chart-svg .band:focus {\n  outline: none;\n}\n\n.chart-svg .band:focus-visible .band-indicator {\n  opacity: 1;\n}\n\n.chart-tooltip {\n  position: absolute;\n  z-index: 5;\n  min-width: 150px;\n  padding: 10px 12px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: var(--surface);\n  box-shadow: var(--shadow-pop);\n  pointer-events: none;\n  font-size: 12px;\n  color: var(--text-2);\n}\n\n.chart-tooltip .tt-title {\n  font-size: 12px;\n  color: var(--text-3);\n  margin-bottom: 6px;\n}\n\n.chart-tooltip .tt-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 3px;\n}\n\n.chart-tooltip .tt-key {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--text-2);\n}\n\n.chart-tooltip .tt-key .key-line {\n  width: 10px;\n  height: 3px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n\n.chart-tooltip .tt-val {\n  font-weight: 650;\n  color: var(--text-1);\n  font-variant-numeric: tabular-nums;\n}\n\n.chart-legend {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  font-size: 12px;\n  color: var(--text-2);\n}\n\n.chart-legend .legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.chart-legend .legend-swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n.chart-empty {\n  display: grid;\n  place-items: center;\n  height: 200px;\n  color: var(--text-3);\n  font-size: 13px;\n}\n\n/* 指标切换（segmented） */\n.seg-group {\n  display: inline-flex;\n  gap: 4px;\n  padding: 3px;\n  border-radius: 10px;\n  background: var(--surface-2);\n}\n\n.seg-btn {\n  padding: 4px 12px;\n  border: none;\n  border-radius: 8px;\n  font-size: 12.5px;\n  color: var(--text-2);\n  background: transparent;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n  white-space: nowrap;\n}\n\n.seg-btn.active {\n  background: var(--surface);\n  color: var(--accent);\n  font-weight: 600;\n  box-shadow: 0 1px 3px rgba(11, 11, 11, 0.12);\n}\n\n/* ============ 模型占比内嵌条 ============ */\n\n.share-cell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 110px;\n}\n\n.share-bar-track {\n  flex: 1;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--accent-soft);\n  overflow: hidden;\n}\n\n.share-bar-fill {\n  height: 100%;\n  border-radius: 999px;\n  background: var(--series-1);\n}\n\n.share-cell .share-num {\n  font-size: 12px;\n  color: var(--text-2);\n  font-variant-numeric: tabular-nums;\n  min-width: 44px;\n  text-align: right;\n}\n\n/* ============ 缓存徽标 ============ */\n\n.cache-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11.5px;\n  line-height: 1;\n  color: var(--text-2);\n  font-variant-numeric: tabular-nums;\n}\n\n.cache-chip .dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  display: inline-block;\n  flex-shrink: 0;\n}\n\n/* ============ 空状态 ============ */\n\n.empty-state {\n  text-align: center;\n  padding: 72px 24px;\n  color: var(--text-3);\n}\n\n.empty-state .empty-icon {\n  display: inline-grid;\n  place-items: center;\n  width: 64px;\n  height: 64px;\n  border-radius: 20px;\n  background: var(--accent-soft);\n  color: var(--accent);\n  margin-bottom: 16px;\n}\n\n.empty-state .empty-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--text-2);\n}\n\n.empty-state .empty-sub {\n  margin-top: 6px;\n  font-size: 13px;\n}\n\n/* ============ Semi 组件微调 ============ */\n\n.panel .semi-table {\n  background: transparent;\n}\n\n.panel .semi-table-tbody > .semi-table-row > .semi-table-row-cell {\n  font-variant-numeric: tabular-nums;\n}\n\n.panel .semi-tabs-bar {\n  border-bottom: 1px solid var(--hairline);\n}\n\n.site-tabs .semi-tabs-tab {\n  font-size: 14px;\n}\n\n/* ============ 动画 ============ */\n\n.fade-up {\n  animation: fadeUp 0.5s cubic-bezier(0.22, 1, 0.36, 1) both;\n}\n\n.fade-up-1 { animation-delay: 0.05s; }\n.fade-up-2 { animation-delay: 0.10s; }\n.fade-up-3 { animation-delay: 0.15s; }\n.fade-up-4 { animation-delay: 0.20s; }\n\n@keyframes fadeUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* ============ 响应式 ============ */\n\n@media (max-width: 640px) {\n  .app-main {\n    padding: 0 12px 48px;\n  }\n\n  .app-header {\n    padding: 14px 16px 4px;\n  }\n\n  .hero {\n    padding: 22px 0 12px;\n  }\n\n  .hero-sub {\n    font-size: 13.5px;\n    padding: 0 8px;\n  }\n\n  .search-card {\n    flex-direction: column;\n    align-items: stretch;\n    padding: 12px;\n  }\n\n  .search-card .semi-button {\n    width: 100%;\n  }\n\n  .panel {\n    margin-top: 14px;\n    padding: 14px;\n    border-radius: var(--radius-md);\n  }\n\n  .panel-head {\n    margin-bottom: 12px;\n  }\n\n  /* 折叠标题在窄屏下可换行 */\n  .panel-title-toggle {\n    flex-wrap: wrap;\n  }\n\n  .panel-head-extra {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  /* KPI 瓦片固定两列，字号适度加大保证可读性 */\n  .tiles-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 10px;\n    margin-top: 14px;\n  }\n\n  .stat-tile {\n    padding: 14px;\n  }\n\n  .stat-tile-value {\n    font-size: 24px;\n  }\n\n  .stat-tile-sub {\n    font-size: 11.5px;\n  }\n\n  /* 令牌信息两列 */\n  .token-info-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n  }\n\n  .token-info-item .value {\n    font-size: 16px;\n  }\n\n  /* 筛选行：时间预设占满一行可横向滑动，其余控件全宽堆叠 */\n  .filter-row {\n    margin-top: 14px;\n    padding: 12px;\n  }\n\n  .filter-row > .semi-icon {\n    display: none;\n  }\n\n  .preset-group {\n    display: flex;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .preset-btn {\n    flex: 1;\n    padding: 7px 8px;\n    text-align: center;\n  }\n\n  .filter-date,\n  .filter-models,\n  .filter-search {\n    width: 100% !important;\n    max-width: none;\n  }\n\n  /* 图表头部控件占满一行，图例换行显示 */\n  .seg-group {\n    flex: 1;\n    display: flex;\n  }\n\n  .seg-btn {\n    flex: 1;\n    text-align: center;\n    padding: 6px 8px;\n  }\n\n  .chart-legend {\n    width: 100%;\n    justify-content: flex-end;\n  }\n\n  .empty-state {\n    padding: 48px 16px;\n  }\n\n  /* 窄屏隐藏\"显示第 x 条-第 y 条\"信息文字，避免挤压竖排 */\n  .semi-table-pagination-info {\n    display: none;\n  }\n\n  .semi-table-pagination-outer {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
